
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getStatuses,
  addStatus,
} from '@pingum/app-state-management/status/actions';
import { addError } from '@pingum/app-state-management/error/actions';

import StatusList from './components/StatusList';
import StatusSettingsHeader from './components/StatusSettingsHeader';
import DisplayMessage from '../../widgets/DisplayMessage';

export class EventStatusSettingsComponent extends React.Component {
  constructor(props) {
    super(props);

    if (!props.statusesLoaded) {
      props.getStatuses();
    }

    this.endOfList = { scrollIntoView: () => {} };
  }

  handleAddStatusClick = (newStatusRequest) => {
    this.props.addStatus(newStatusRequest);

    this.endOfList.scrollIntoView({
      block: 'end',
      behavior: 'smooth',
    });
  }

  handleSuggestionClick = (statusesToAdd) => {
    for (let i = 0; i < statusesToAdd.length; i += 1) {
      this.props.addStatus(statusesToAdd[i]);
    }
  }

  render() {
    return (
      <div>
        <StatusSettingsHeader
          onAddStatus={this.handleAddStatusClick}
          onShowInfoModal={this.handleShowModalEvent}
          statuses={this.props.statuses}
        />

        <StatusList
          statuses={this.props.statuses}
          includeArchived={this.props.includeArchived}
          isAddingStatus={this.props.isAddingStatus}
        />

        {
          this.props.statusesLoaded
            && this.props.statuses.length === 0
            && (
              <DisplayMessage
                title="No Statuses"
                icon="error_outline"
              />
            )
        }
        <div ref={(el) => { this.endOfList = el; }} />
      </div>
    );
  }
}

EventStatusSettingsComponent.propTypes = {
  addStatus: PropTypes.func.isRequired,
  getStatuses: PropTypes.func.isRequired,
  includeArchived: PropTypes.bool,
  statuses: PropTypes.array,
  statusesLoaded: PropTypes.bool,
  isAddingStatus: PropTypes.bool,
};

EventStatusSettingsComponent.defaultProps = {
  statuses: [],
  statusesLoaded: false,
  includeArchived: false,
  isAddingStatus: false,
};

export const mapStateToProps = (state) => ({
  statuses: state.status.statuses,
  statusesLoaded: state.status.statusesLoaded,
  includeArchived: state.status.includeArchived,
  isAddingStatus: state.status.isAddingStatus,
});

export const mapDispatchToProps = (dispatch) => ({
  addStatus: (request) => dispatch(addStatus(request)),
  getStatuses: (includeArchived) => dispatch(getStatuses(includeArchived)),
  addError: (error) => dispatch(addError(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventStatusSettingsComponent);
